import axiosInstance from "../api";
import {
  GET_CATEGORY_BY_ID_FOR_HIRE,
  GET_FILTERD_HIRE_EXPERT,
  GET_FOLLOW_PROFILE,
  GET_INDUSTRY_CATEGORY_FOR_HIRE,
  GET_PROFILE,
  GET_USER_FOR_HIRE,
  GET_USER_PROFILE,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const HireExpert = (data, navigate) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("post/create", data);
    if (response?.data?.status) {
      navigate(
        `/${data?.lan}/jobcontract/${response?.data?.response?.proposal_id}`, { state: { owner: true, its: 'hiring', expert_id: data?.expert_id } }
      );
      urtoast(response?.data?.response?.message, 1);
      return response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const FilterHireExpertListings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("proposal/search", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_HIRE_EXPERT, getfilterdhiredexpert: response.data?.response });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};


export const getUserListforHire = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(`proposal/create`, data);
    if (response?.data?.status) {
      dispatch({
        type: GET_USER_FOR_HIRE,
        getusesforhire: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getUserProfile = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auth/get-profile?user_id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_USER_PROFILE,
        getuserprofile: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getFollowProfile = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`auth/follow?user_id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_FOLLOW_PROFILE,
        getfollowprofile: response?.data?.response,
      });
      dispatch(getUserProfile(id));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    urtoast(err.message, 1);
  }
};

export const getIndustrucatagoryforHire = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category?type=1&sub=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_INDUSTRY_CATEGORY_FOR_HIRE,
        getindustrucatagoryforhire: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getCatagorybyidforHire = (id, search) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `category?type=2&parent_id=${id}&sub=1&search=${search}`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_CATEGORY_BY_ID_FOR_HIRE,
        getcatagorybyidforhire: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
